import {Component} from 'react';
import {NavLink} from 'react-router-dom';
import Swal from 'sweetalert2';

import http from 'services/http';
import formatMoney from 'utils/formatMoney';
import styles from './styles.module.css';
import PermissionGate from "../../../../utils/PermissionGate";
import {alerta} from "../../../../components/Alert";

export default class index extends Component {


    constructor(props) {
        super(props);

        this.state = {
            gerentes: [],
            cambistas: [],
            supervisores: [],
            operadores: [],
            gerente: 0,
            cambista: '',
            supervisor: '',
            loading: true,
            nivel: '',
        };

    }

    componentDidMount() {
        const buscaNivel = async () => {
            const nivel = await localStorage.getItem('nivel');
            this.setState({nivel});
        }
        buscaNivel();

        if (localStorage.getItem('nivel') === 'admin') {
            this.buscarGerentes();
            this.buscarSupervisores();
        }

        this.buscarCambistas();
        this.buscarCaixa();
    }

    buscarGerentes = async () => {
        try {
            const response = await http.get('/usuarios', {
                params: {
                    nivel: 'gerente',
                    resumida: true
                }
            });
            const usuarios = response.data.data;

            this.setState({gerentes: usuarios});
        } catch (e) {
        }
    };

    buscarSupervisores = async () => {
        try {
            const response = await http.get('/supervisores', {params: {resumida: true}});

            this.setState({supervisores: response.data.data ?? []});
        } catch (e) {
        }
    };

    // Sem escopo traz todos os cambistas; com gerente ou grupo, só os de dentro dele.
    // A lista também define o recorte do grupo na tabela, que é filtrada no cliente.
    buscarCambistas = async ({gerenteId, supervisorId} = {}) => {
        try {
            const response = await http.get('/usuarios', {
                params: {
                    nivel: 'operador',
                    resumida: true,
                    gerente_id: gerenteId || undefined,
                    supervisor_id: supervisorId || undefined,
                }
            });

            this.setState({cambistas: response.data.data ?? []});
        } catch (e) {
        }
    };

    // Grupo e gerente são excludentes; trocar qualquer um dos dois zera o cambista.
    mudarSupervisor = (supervisor) => {
        this.setState({supervisor, gerente: 0, cambista: ''});
        this.buscarCambistas({supervisorId: supervisor});
    };

    mudarGerente = (gerente) => {
        this.setState({gerente, supervisor: '', cambista: ''});
        this.buscarCambistas({gerenteId: gerente});
    };

    buscarCaixa = async () => {
        try {
            const response = await http.get('/prestacao');

            const operadores = response.data.data.map((op) => {
                op.id = op.cambista_id;
                op.nome = op.cambista;
                op.entrada = formatMoney(op.entrada);
                op.entrada_aberta = formatMoney(op.entrada_aberta);
                op.saidas = formatMoney(op.saida);
                op.comissoes = formatMoney(op.comissao_cambista);
                op.lancamentos = formatMoney(op.lancamento);
                op.valor_total = op.total_cambista;
                op.total = formatMoney(op.total_cambista);
                return op;
            });

            this.setState({operadores});
        } catch (e) {
        }

        this.setState({loading: false});
    };

    filtrarOperadores = () => {
        const {gerente, cambista, supervisor, operadores, cambistas} = this.state;

        if (cambista) {
            return operadores.filter((op) => op.cambista_id == cambista);
        }

        if (gerente > 0) {
            return operadores.filter((op) => op.gerente_id == gerente);
        }

        if (supervisor) {
            // A lista de cambistas já vem restrita ao grupo pela API.
            const doGrupo = new Set(cambistas.map((c) => String(c.id)));
            return operadores.filter((op) => doGrupo.has(String(op.cambista_id)));
        }

        return operadores;
    };

    prestarContasTodos = async () => {
        try {
            this.setState({loading: false});

            const {gerente} = this.state;

            const res = await http.post(`prestacao/cambista`, {
                gerente_id: gerente
            });

            alerta(res.data)

            this.buscarCaixa(localStorage.getItem('nivel'));
        } catch (e) {
        }
    };

    perguntaPrestarContas = () => {
        Swal.fire({
            title: 'Atenção!',
            text: 'Antes de prestar contas com todos, entre em caixa, clique em resumo para fechamento e salve a prestação de contas, pois ação deste botão é zerar todos os caixas e não tem como desfazer a após a confirmação. OBS. Aguarde ate a função carregar completamente, não feche a pagina!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                this.prestarContasTodos();
            }
        });
    };

    render() {
        console.log(this.state.gerente)
        return (
            <>
                <div className="titulo-principal">
                    Prestar Contas
                </div>
                <PermissionGate permissions={["Prestação cambista"]}>
                    {/* Sem rótulos: o nome do filtro é a própria opção vazia do select. */}
                    <div className="conteudo-principal d-flex quatro-colunas justify-content-start">
                        {this.state.nivel === 'admin' && (
                            <select
                                className="form-control"
                                onChange={(e) => this.mudarSupervisor(e.target.value)}
                                value={this.state.supervisor}
                            >
                                <option value="">Grupo Gerentes</option>
                                {this.state.supervisores.map((s) => (
                                    <option key={s.id} value={s.id}>
                                        {s.nome}
                                    </option>
                                ))}
                            </select>
                        )}

                        {this.state.nivel === 'admin' && (
                            <select
                                className="form-control"
                                onChange={(e) => this.mudarGerente(e.target.value)}
                                value={this.state.gerente}
                            >
                                <option value="0">Gerente</option>
                                {this.state.gerentes.map((g) => (
                                    <option key={g.id} value={g.id}>
                                        {g.login.toUpperCase()}
                                    </option>
                                ))}
                            </select>
                        )}

                        <select
                            className="form-control"
                            onChange={(e) => this.setState({cambista: e.target.value})}
                            value={this.state.cambista}
                        >
                            <option value="">Cambista</option>
                            {this.state.cambistas.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.login.toUpperCase()}
                                </option>
                            ))}
                        </select>

                        <button
                            onClick={() => this.perguntaPrestarContas()}
                            className="btn btn-info btn-menu-prestacao"
                        >
                            Prestar conta com todos
                        </button>
                    </div>
                </PermissionGate>
                {this.state.loading ? (
                    <div className="loader"/>
                ) : (
                    <div className="table-responsive m-t">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Cambista</th>
                                <th>Entrada</th>
                                <th>Saídas</th>
                                <th>Comissão</th>
                                <th>Lançamentos</th>
                                <th>Total</th>
                                <th>Última Prestação</th>
                                <PermissionGate permissions={["Prestação cambista"]}>
                                    <th>Prestação</th>
                                </PermissionGate>
                            </tr>
                            </thead>
                            <tbody>
                            {this.filtrarOperadores().map((operador) => (
                                <tr key={operador.id}>
                                    <td>
                                        <b>{operador.nome}</b>
                                    </td>
                                    <td>{operador.entrada}</td>
                                    <td>{operador.saidas}</td>
                                    <td>{operador.comissoes}</td>
                                    <td>{operador.lancamentos}</td>
                                    <td>
                                        <b
                                            className={`${
                                                operador.valor_total > 0 ? 'text-success' : ''
                                            } ${operador.valor_total < 0 ? 'text-danger' : ''}`}
                                        >
                                            {operador.total}
                                        </b>
                                    </td>
                                    <td>
                                        {operador.ultima_prestacao
                                            ? new Date(operador.ultima_prestacao).toLocaleString('pt-BR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
                                            : <span style={{color: '#999'}}>Nunca</span>
                                        }
                                    </td>
                                    <PermissionGate permissions={["Prestação cambista"]}>
                                        <td style={{display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap'}}>
                                            <NavLink
                                                className={`btn-prestacao ${styles.buttonHover}`}
                                                to={`/prestacao/cambistas/${operador.id}`}
                                            >
                                                Prestar contas
                                            </NavLink>
                                        </td>
                                    </PermissionGate>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </>
        );
    }
}
